import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function RefundPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50 min-h-screen">
      <Header />
      <div className="max-w-4xl mx-auto px-4 pt-32 pb-12 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Refund and Cancellation Policy</h1>
        
        <div className="bg-white rounded-xl shadow-sm p-8 space-y-6 text-gray-700 leading-relaxed">
          <p className="mb-4">
            This refund and cancellation policy outlines how you can cancel or seek a refund for a product / service that you have purchased through the Platform. Under this policy:
          </p>

          <ol className="list-decimal pl-5 space-y-4">
            <li>
              Cancellations will only be considered if the request is made 3 days of placing the order.
            </li>
            <li>
              In case of any refunds approved by Ecom Tamil-9360326064 to you, it will take 7 days for the refund to be processed.
            </li>
          </ol>
        </div>
      </div>
      <Footer />
    </div>
  );
}
